import { dashboardActions } from "../../constants/actionTypes";
import { dashboard_labels, dashboard_units } from "../../constants/componentConstants";
const INITIAL_STATE = {
  loadingResourcesInfo: false,
  resourceProviderLoading: false,
  tenantStatLoading: false,
  userStatLoading: false,
  pendingActionLoading: false,
  vmStatsLoading: false,
  billingStatsLoadingLast: false,
  billingStatsLoadingCurr: false,
  allVMSLoading: false,
  trendingLabsLoading: false,
  usageTrendsLoading: false,
  usageHoursLoading: false,
  forecastLoading: false,
  resourceProviderListDashboard: [{ id: "all", key: "all", label: "All Resources", connection_name: "All Resources" }],
  resourceProviderListDashboardError: "",
  privateCloudAccounts: [{ name: "Vcenter", value: 1, realVal: 0 }],
  privateCloudAccountsPercentage: "0",
  cpuAvailPercentage: 0,
  memAvailPercentage: 0,
  totalConnections: 0,
  resourcesInfoDashboardError: "",
  tenantStatsError: false,
  cpuConsumption: [
    {
      name: dashboard_labels?.used,
      value: 0,
      realVal: `0 ${dashboard_units?.cpu}`,
    },
    {
      name: dashboard_labels?.available,
      value: 100,
      realVal: `0 ${dashboard_units?.cpu}`,
    },
  ],
  cpuConsumptionLoaded: false,
  memoryConsumptionLoaded: false,
  privateCloudAccountsLoaded: false,
  memoryConsumption: [
    {
      name: dashboard_labels?.used,
      value: 0,
      realVal: `0 ${dashboard_units?.mem}`,
    },
    {
      name: dashboard_labels?.available,
      value: 100,
      realVal: `0 ${dashboard_units?.mem}`,
    },
  ],
  tenantStats: {
    count: "",
    recently_added: [],
    more: "",
  },
  tenantUserStats: [
    {
      name: dashboard_labels?.activeUsers,
      value: 0,
      realVal: 0,
    },
    {
      name: dashboard_labels?.totalUsers,
      value: 1,
      realVal: 0,
    },
  ],
  vmStats: {
    windows: 0,
    linux: 0,
    running: 0,
    expired: 0,
    expiring_in_seven_days: 0,
    deleted: 0,
    total: 0,
    provisioned_this_week: 0,
    mon: 0,
    tue: 0,
    wed: 0,
    thu: 0,
    fri: 0,
    sat: 0,
    sun: 0,
    weeklyStat: [
      { name: "S", filled: 0, remaining: 1 },
      { name: "M", filled: 0, remaining: 1 },
      { name: "T", filled: 0, remaining: 1 },
      { name: "W", filled: 0, remaining: 1 },
      { name: "T", filled: 0, remaining: 1 },
      { name: "F", filled: 0, remaining: 1 },
      { name: "S", filled: 0, remaining: 1 },
    ],
  },
  usersList: [{ id: "all", key: "all", label: "All", tenant_name: "All" }],
  usersListSearching: false,
  pendingActionsCount: 0,
  billingStats: {
    currMonth: [
      {
        key: "week1",
        name: `WEEK 1`,
        amt: 0,
        forecast: 0,
      },
      {
        key: "week2",
        name: `WEEK 2`,
        amt: 0,
        forecast: 0,
      },
      {
        key: "week3",
        name: `WEEK 3`,
        amt: 0,
        forecast: 0,
      },
      {
        key: "week4",
        name: `WEEK 4`,
        amt: 0,
        forecast: 0,
      },
    ],
    lastMonth: [
      {
        key: "week1",
        name: `WEEK 1`,
        amt: 0,
      },
      {
        key: "week2",
        name: `WEEK 2`,
        amt: 0,
      },
      {
        key: "week3",
        name: `WEEK 3`,
        amt: 0,
      },
      {
        key: "week4",
        name: `WEEK 4`,
        amt: 0,
      },
    ],
  },
  allVMs: null,
  allTrendingLabs: null,
  usageTrends: {
    usageTrendsDaily: [
      { name: "00:00", value: 0 },
      { name: "04:00", value: 0 },
      { name: "08:00", value: 0 },
      { name: "12:00", value: 0 },
      { name: "16:00", value: 0 },
      { name: "20:00", value: 0 },
    ],
    usageTrendsWeekly: [
      { name: "M", value: 0 },
      { name: "T", value: 0 },
      { name: "W", value: 0 },
      { name: "T", value: 0 },
      { name: "F", value: 0 },
      { name: "S", value: 0 },
      { name: "S", value: 0 },
    ],
  },
  usageHours: [
    {
      name: dashboard_labels?.total,
      value: 0,
      realVal: 0,
    },
    {
      name: dashboard_labels?.available,
      value: 1,
      realVal: 0,
    },
  ],
  resourceProviderCount: {
    data: {}
  }
};
const getStatsForLastMonth = (chart_labels = [], chart_values = []) => {
  return chart_labels?.map?.((week, index) => ({
    key: week,
    name: `WEEK ${index + 1}`,
    amt: chart_values?.[index] || 0,
  }));
};
const getStatsForCurrMonth = (chart_labels = [], chart_values = []) => {
  return chart_labels?.map?.((week, index) => ({
    key: week,
    name: `WEEK ${index + 1}`,
    forecast: 0,
    curr: chart_values?.[index] || 0,
  }));
};

const mapUsageTrends = (chart_labels = [], chart_values = []) => {
  return chart_labels?.map?.((name, index) => ({
    name,
    value: chart_values?.[index] || 0,
  }));
};
// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case dashboardActions.apiActionSet:
      return {
        ...state,
        ip: action?.payload,
      };
    case dashboardActions.resourceProviderDashboardSuccess:
      return {
        ...state,
        privateCloudAccounts: [{ name: "Vcenter", value: action?.payload?.count, realVal: action?.payload?.count }],
        privateCloudAccountsPercentage: action?.payload?.count,
        privateCloudAccountsLoaded: true,
        resourceProviderListDashboard: [
          ...state?.resourceProviderListDashboard,
          ...action?.payload?.results?.map?.((item) => ({
            ...item,
            key: item?.id,
            label: item?.connection_name,
            value: item?.id,
          })),
        ],
      };
    case dashboardActions.resetProviderList:
      return {
        ...state,
        resourceProviderListDashboard: INITIAL_STATE.resourceProviderListDashboard,
      };
    case dashboardActions.resourceProviderDashboardError:
      return {
        ...state,
        resourceProviderListDashboard: INITIAL_STATE.resourceProviderListDashboard,
        resourceProviderListDashboardError: action?.payload,
        privateCloudAccounts: null,
        cpuConsumption: null,
        memoryConsumption: null,
        totalConnections: null,
      };

    case dashboardActions.setResProviderListLoading:
      return { ...state, resourceProviderLoading: action.payload };
    case dashboardActions.resourcesInfoDashboardSuccess:
      return {
        ...state,
        totalConnections: action.payload?.vmware_total_connected_hosts,
        cpuAvailPercentage:
          action?.payload?.vmware_total_hosts_cpu_available_percentage !== "NA"
            ? parseInt((100 - action?.payload?.vmware_total_hosts_cpu_available_percentage)?.toFixed(2))
            : action?.payload?.vmware_total_hosts_cpu_available_percentage,
        memAvailPercentage:
          action?.payload?.vmware_total_hosts_mem_available_percentage !== "NA"
            ? parseInt((100 - action?.payload?.vmware_total_hosts_mem_available_percentage)?.toFixed(2))
            : action?.payload?.vmware_total_hosts_mem_available_percentage,
        cpuConsumption: [
          {
            name: dashboard_labels?.used,
            value:
              action?.payload?.vmware_total_hosts_cpu_available_percentage !== "NA"
                ? parseInt((100 - action?.payload?.vmware_total_hosts_cpu_available_percentage)?.toFixed(2))
                : 0,
            realVal:
              action?.payload?.vmware_total_hosts_cpu_usage !== "NA"
                ? `${action?.payload?.vmware_total_hosts_cpu_usage?.toFixed(2)} ${dashboard_units?.cpu}`
                : action?.payload?.vmware_total_hosts_cpu_usage,
          },
          {
            name: dashboard_labels?.available,
            value:
              action?.payload?.vmware_total_hosts_cpu_available_percentage !== "NA"
                ? parseInt(action?.payload?.vmware_total_hosts_cpu_available_percentage?.toFixed(2))
                : 1,
            realVal:
              action?.payload?.vmware_total_hosts_cpu_max !== "NA"
                ? `${action?.payload?.vmware_total_hosts_cpu_max?.toFixed(2)} ${dashboard_units?.cpu}`
                : action?.payload?.vmware_total_hosts_cpu_max,
          },
        ],
        memoryConsumption: [
          {
            name: dashboard_labels?.used,
            value:
              action?.payload?.vmware_total_hosts_mem_available_percentage !== "NA"
                ? parseInt((100 - action?.payload?.vmware_total_hosts_mem_available_percentage)?.toFixed(2))
                : 0,
            realVal:
              action?.payload?.vmware_total_hosts_memory_usage !== "NA"
                ? `${action?.payload?.vmware_total_hosts_memory_usage?.toFixed(2)} ${dashboard_units?.mem}`
                : action?.payload?.vmware_total_hosts_memory_usage,
          },
          {
            name: dashboard_labels?.available,
            value:
              action?.payload?.vmware_total_hosts_mem_available_percentage !== "NA"
                ? parseInt(action?.payload?.vmware_total_hosts_mem_available_percentage?.toFixed(2))
                : 1,
            realVal:
              action?.payload?.vmware_total_hosts_memory_max !== "NA"
                ? `${action?.payload?.vmware_total_hosts_memory_max?.toFixed(2)} ${dashboard_units?.mem}`
                : action?.payload?.vmware_total_hosts_memory_max,
          },
        ],
        cpuConsumptionLoaded: true,
        memoryConsumptionLoaded: true,
      };
    case dashboardActions.resourcesInfoDashboardError:
      return {
        ...state,
        totalConnections: null,
        resourcesInfoDashboard: {},
        cpuConsumption: null,
        memoryConsumption: null,
        resourcesInfoDashboardError: action?.payload,
      };
    case dashboardActions.setLoadingDashboard:
      return { ...state, loadingDashboard: action?.payload };
    case dashboardActions.setloadingResourcesInfo:
      return { ...state, loadingResourcesInfo: action?.payload };
    case dashboardActions.tenantDashboardSuccess:
      return { ...state, tenantStats: action?.payload, tenantStatsError: false };
    case dashboardActions.tenantDashboardError:
      return { ...state, tenantStats: null, tenantStatsError: true };
    case dashboardActions.setLoadingDashboardTenStats:
      return { ...state, tenantStatLoading: action?.payload };
    case dashboardActions.userDashboardSuccess:
      const active = action?.payload?.active === "NA" ? 0 : action?.payload?.active;
      return {
        ...state,
        tenantUserStats: [
          {
            name: dashboard_labels?.activeUsers,
            value: action?.payload?.active === "NA" ? 0 : action?.payload?.active,
            realVal: action?.payload?.active,
          },
          {
            name: dashboard_labels?.totalUsers,
            value: action?.payload?.total === "NA" || action?.payload?.total === 0 ? 1 : action?.payload?.total - active,
            realVal: action?.payload?.total,
          },
        ],
      };
    case dashboardActions.userDashboardError:
      return { ...state, tenantUserStats: null };
    case dashboardActions.setLoadingDashboardUserStats:
      return { ...state, userStatLoading: action.payload };
    case dashboardActions.userDropdownDashboardSuccess:
      return {
        ...state,
        usersList: [
          ...state?.usersList,
          ...action?.payload?.results?.map?.((item) => ({ ...item, key: item?.id, label: item?.tenant_name, value: item?.id })),
        ],
      };
    case dashboardActions.userDropdownDashboardError:
      return { ...state, usersList: INITIAL_STATE.usersList };
    case dashboardActions.usersListSearching:
      return { ...state, usersListSearching: action?.payload };
    case dashboardActions.pendingActionsDashboardSuccess:
      return { ...state, pendingActionsCount: action?.payload };
    case dashboardActions.pendingActionsDashboardError:
      return { ...state, pendingActionsCount: null };
    case dashboardActions.setPendingActionLoading:
      return { ...state, pendingActionLoading: action?.payload };
    case dashboardActions.vmStatsSuccess: {
      const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
      return {
        ...state,
        vmStats: {
          ...action?.payload,
          total: action?.payload?.total === 0 || action?.payload?.total === "NA" ? 0 : action?.payload?.total,
          provisioned_this_week:
            action?.payload?.provisioned_this_week === 0 || action?.payload?.provisioned_this_week === "NA"
              ? 0
              : action?.payload?.provisioned_this_week,
          running: action?.payload?.running === 0 || action?.payload?.running === "NA" ? 0 : action?.payload?.running,
          expired: action?.payload?.expired === 0 || action?.payload?.expired === "NA" ? 0 : action?.payload?.expired,
          expiring_in_seven_days:
            action?.payload?.expiring_in_seven_days === 0 || action?.payload?.expiring_in_seven_days === "NA"
              ? 0
              : action?.payload?.expiring_in_seven_days,
          deleted: action?.payload?.deleted === 0 || action?.payload?.deleted === "NA" ? 0 : action?.payload?.deleted,
          weeklyStat: days.map((item) => ({
            name: item?.charAt(0)?.toUpperCase(),
            filled:
              action?.payload?.provisioned_this_week === 0 || action?.payload?.provisioned_this_week === "NA" ? 0 : action?.payload?.[item],
            remaining:
              action?.payload?.provisioned_this_week === 0 || action?.payload?.provisioned_this_week === "NA"
                ? 1
                : action?.payload?.provisioned_this_week - action?.payload?.[item],
          })),
        },
      };
    }
    case dashboardActions.vmStatsError:
      return { ...state, vmStats: null };
    case dashboardActions.setLoadingDashboardVMStats:
      return { ...state, vmStatsLoading: action?.payload };
    case dashboardActions.billingStatsCurrMonthDashboardSuccess:
      return {
        ...state,
        billingStats: {
          ...state?.billingStats,
          currency: action?.payload?.currency || "INR",
          currMonth: getStatsForCurrMonth(action?.payload?.chart_labels, action?.payload?.chart_values),
          totalBillCurr: action?.payload?.billing_amount ? parseInt?.(action?.payload?.billing_amount)?.toFixed(2) : 0,
          growthPoints: null,
        },
      };
    case dashboardActions.billingStatsLastMonthDashboardSuccess:
      return {
        ...state,
        billingStats: {
          ...state?.billingStats,
          currency: action?.payload?.currency || "INR",
          totalBillLast: action?.payload?.billing_amount ? parseInt?.(action?.payload?.billing_amount)?.toFixed(2) : 0,
          lastMonth: getStatsForLastMonth(action?.payload?.chart_labels, action?.payload?.chart_values),
          growthPoints: null,
        },
      };
    case dashboardActions.forecastDashboardSuccess:
      return {
        ...state,
        billingStats: {
          ...state.billingStats,
          currMonthForecast: action?.payload,
        },
      };

    case dashboardActions.forecastDashboardError: {
      return {
        ...state,
        billingStats: {
          ...state.billingStats,
          currMonthForecast: [],
        },
      };
    }

    case dashboardActions.setLoadingForecast:
      return {
        ...state,
        forecastLoading: action?.payload,
      };
    case dashboardActions.billingStatsDashboardError:
      return {
        ...state,
        billingStats:
          action?.payload === "last_month"
            ? { ...state?.billingStats, lastMonth: null, totalBillLast: 0, growthPoints: null }
            : {
              ...state?.billingStats,
              currMonth: null,
              totalBillCurr: 0,
              growthPoints: null,
            },
      };
    case dashboardActions.setLoadingDashboardBillingInfoLast:
      return { ...state, billingStatsLoadingLast: action?.payload };
    case dashboardActions.setLoadingDashboardBillingInfoCurr:
      return { ...state, billingStatsLoadingCurr: action?.payload };
    case dashboardActions.ALLVMsDashboardSuccess:
      return { ...state, allVMs: action?.payload };
    case dashboardActions.ALLVMsDashboardError:
      return { ...state, allVMs: INITIAL_STATE.allVMs };
    case dashboardActions.setLoadingAllVMs:
      return { ...state, allVMSLoading: action?.payload };
    case dashboardActions.ALLTrendingLabsDashboardSuccess:
      return { ...state, allTrendingLabs: action?.payload };
    case dashboardActions.ALLTrendingLabsDashboardError:
      return { ...state, allTrendingLabs: INITIAL_STATE.allVMs };
    case dashboardActions.setLoadingAllTrendLabs:
      return { ...state, trendingLabsLoading: action?.payload };
    case dashboardActions.usageTrendsDashboardDailySuccess:
      return {
        ...state,
        usageTrends: {
          ...state?.usageTrends,
          usageTrendsDaily: mapUsageTrends(action?.payload?.chart_labels, action?.payload?.chart_values),
        },
      };
    case dashboardActions.usageTrendsDashboardWeeklySuccess:
      return {
        ...state,
        usageTrends: {
          ...state?.usageTrends,
          usageTrendsWeekly: mapUsageTrends(action?.payload?.chart_labels, action?.payload?.chart_values),
        },
      };
    case dashboardActions.usageTrendsDashboardError:
      return {
        ...state,
        usageTrends:
          action?.payload === "daily"
            ? { ...state?.usageTrends, usageTrendsDaily: null }
            : { ...state?.usageTrends, usageTrendsWeekly: null },
      };
    case dashboardActions.setLoadingUsageTrends:
      return { ...state, usageTrendsLoading: action?.payload };
    case dashboardActions.setLoadingUsageHours:
      return { ...state, usageHoursLoading: action?.payload };

    case dashboardActions.UsageHoursDashboardSuccess:
      const used =
        action?.payload?.total_minutes !== "NA" && action?.payload?.available_minutes !== "NA"
          ? action?.payload?.total_minutes - action?.payload?.available_minutes
          : 0;

      return {
        ...state,
        usageHours: [
          {
            name: dashboard_labels?.total,
            value: used,
            realVal: action?.payload?.total_minutes,
          },
          {
            name: dashboard_labels?.available,
            value:
              action?.payload?.available_minutes === "NA" || action?.payload?.total_minutes === "NA"
                ? 1
                : action?.payload?.available_minutes,
            realVal: action?.payload?.available_minutes,
          },
        ],
      };
    case dashboardActions.UsageHoursDashboardError:
      return {
        ...state,
        usageHours: null,
      };
    case dashboardActions.UPDATE_DASHBOARD_VM_STATE:
      let vmList = state.allVMs;
      vmList?.length > 0 && vmList?.forEach((element) => {
        if (element?.id === action?.payload?.payload?.vm) {
          element.vm_status = action?.payload?.payload?.vm_state;
        }
      });
      return {
        ...state,
        allVMs: vmList,
      };

    case dashboardActions.RESOURSE_PROVIDER_COUNT_SUCCESS: {
      return {
        ...state,
        resourceProviderCount: {
          ...state?.resourceProviderCount,
          data: action?.payload || {},
        },
      };
    }

    default:
      return state;
  }
}
